export default [
  {
    question: '¿Qué es Bigbox+?',
    answer:
      '<p>Bigbox+ es un programa exclusivo para regaladores extraordinarios. Al convertirte en miembro Bigbox+, disfrutarás de beneficios únicos y acceso a experiencias exclusivas en Argentina.</p>',
  },
  {
    question: '¿Cómo puedo convertirme en Bigbox+?',
    answer:
      '<p>Para convertirte en Bigbox+, solo necesitas comprar 4 regalos en Argentina con una misma cuenta de mail, ya sea en web o en nuestros puntos de venta, en los últimos 12 meses desde la fecha de hoy. Una vez que hayas alcanzado este requisito, automáticamente serás parte del programa por un año.</p><p>Las compras realizadas con factura A no cuentan para calificar en el programa.</p><p>Las compras con crédito no cuentan para calificar en el programa.</p>',
  },
  {
    question: '¿Qué beneficios obtengo como miembro de Bigbox+?',
    answer:
      '<p>Al ser Bigbox+, disfrutarás de los siguientes beneficios:</p><ul><li>Experiencias y contenido exclusivo: Acceso a contenido especial dentro de nuestra plataforma.</li><li>5% en crédito: Te devolvemos el 5% de cada compra en crédito Plus para seguir regalando. La devolución se aplica sobre el monto efectivamente pagado. Si una parte fue abonada con crédito Plus sobre esa parte no se genera devolución. No generarán crédito Plus compras con Factura A y/o compras utilizando crédito con origen distinto a crédito Plus (por ejemplo crédito generado por el cambio de un regalo, promos de cashback, etc.). </li><li>Envíos gratis: Envío sin costo para todos los regalos físicos.</li><li>Atención personalizada: Acceso a un canal de atención especial vía WhatsApp para todas tus consultas.</li></ul>',
  },
  {
    question: '¿Cuánto tiempo dura mi membresía Bigbox+?',
    answer:
      '<p>Tu membresía Bigbox+ es válida por 12 meses desde el momento en que ingresas al programa. Durante ese tiempo, podrás disfrutar de todos los beneficios mencionados.</p>',
  },
  {
    question: '¿Cómo accedo al contenido exclusivo?',
    answer:
      '<p>El contenido exclusivo para miembros Bigbox+ estará disponible cuando inicies sesión en nuestra web en una página exclusiva. Podrás ver todas las experiencias y eventos especiales que solo están disponibles para los miembros.</p>',
  },
  {
    question: '¿Cómo funciona el beneficio del crédito?',
    answer:
      '<p>Cada vez que compres, si cumples con las condiciones te generamos automáticamente un crédito correspondiente al 5% de lo efectivamente pagado, en tu cuenta Bigbox. Si una parte fue abonada con crédito Bigbox+ sobre esa parte no se genera devolución. No generarán crédito Plus compras con Factura A y/o compras utilizando crédito con origen distinto a crédito Plus (por ejemplo crédito generado por el cambio de un regalo, promos de cashback, etc.).</p><p>El crédito Plus podrás usarlo para realizar compras en nuestra web o en nuestros puntos de venta aplicando el mismo durante el proceso de pago.</p>',
  },
  {
    question: '¿Cómo accedo al envío gratis?',
    answer:
      '<p>El envío gratis estará disponible cuando inicies sesión en nuestra web y compres una Bigbox física con envío a domicilio. Aplica a envíos a todo el país. Lo verás reflejado antes de abonar en el carrito de compra.</p>',
  },
  {
    question:
      '¿Cómo puedo contactar al soporte especial para miembros Bigbox+?',
    answer:
      '<p>Como miembro Bigbox+, tenés acceso a un canal exclusivo de atención personalizada por WhatsApp. Puedes encontrar el link de contacto en la sección de "Atención Personalizada" que verás en la sección de Bigbox+ cuando estés logueado con tu usuario.</p>',
  },
  {
    question: '¿Qué sucede si no compro 4 regalos en los próximos 12 meses?',
    answer:
      '<p>Si no alcanzas el requisito de 4 regalos en el período de 12 meses, tu membresía Bigbox+ expirará y perderás acceso a los beneficios exclusivos. Sin embargo, siempre podrás volver a calificar al comprar la cantidad necesaria de regalos.</p>',
  },
  {
    question: '¿Qué pasa si compré con factura A o por el canal corporativo?',
    answer:
      '<p>Las compras realizadas con factura A o desde el canal corporativo no cuentan para calificar en el programa Bigbox+.</p>',
  },
  {
    question: 'Si compré con 2 mails diferentes, ¿puedo sumar las compras?',
    answer:
      '<p>La forma en que identificamos un usuario es mediante el mail. Por lo que si compraste con 2 mails diferentes, las compras no se suman. Los 4 regalos tienen que estar comprados con el mismo usuario de mail.</p>',
  },
];
